const useJsonLdWebsite = () => {
  const state = useState<object|null>(() => null)

  const setWebsite = (name: string, alternateName: string, url: string) => {
    if (!name || !alternateName || !url) {
      state.value = null
      return
    }

    state.value = {
      name,
      alternateName,
      url
    }
  }

  const getAssembledObject = (): object|null => {
    if (!state.value) {
      return null
    }

    return {
      '@type': 'WebSite',
      name: state.value.name,
      alternateName: state.value.alternateName,
      url: state.value.url
    }
  }

  return {
    setWebsite,
    getAssembledObject
  }
}

export default useJsonLdWebsite
